import React, { useState } from "react";
import { Box, TextField, Typography, Button } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSendEmail = () => {
    if (!email) {
      Swal.fire({
        icon: "error",
        title: "Email Tidak Boleh Kosong",
        text: "Masukkan email Anda untuk melanjutkan.",
        confirmButtonColor: "#0F62FE",
      });
      return;
    }
    
    Swal.fire({
      icon: "success",
      title: "Email Terkirim!",
      text: "Silakan periksa email Anda untuk mengatur ulang password.",
      confirmButtonColor: "#0F62FE",
    }).then(() => {
      navigate("/login");
    });
  };

  return (
    <Box sx={{ width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "#F2F4F8" }}>
      <Box sx={{ width: 680, padding: "80px", background: "white", border: "1px solid #DDE1E6", borderRadius: "8px", display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
        <Typography variant="h4" fontWeight={700} color="#21272A" textAlign="center">
          Lupa Password ?
        </Typography>
        <Typography variant="body1" color="#21272A" textAlign="center">
          Masukkan email untuk mengetahui password & melakukan login ulang
        </Typography>
        <TextField 
          fullWidth 
          label="Email Address"
          variant="outlined"
          placeholder="Enter personal or work email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ background: "#F2F4F8", borderBottom: "1px solid #C1C7CD" }}
        />
        <Button fullWidth variant="contained" sx={{ background: "#0F62FE", padding: "12px", fontSize: "16px" }} onClick={handleSendEmail}>
          Send password details
        </Button>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
